<div class="dialog-heading">
    <h5>{{ data.title }}</h5>
    <span class="flex-fill"></span>
    <mat-icon class="close-dialog" aria-hidden="false" [mat-dialog-close]="{ confirmed: false }" aria-label="Close icon"> close</mat-icon>
  </div>
  <mat-dialog-content >  
    <div class="padTop">      
      <p>
        {{ this.getQuoteAcceptanceDisclaimer() }}
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button mat-flat-button color="accent" (click)="markOfferReadyForReview()">Ok</button>
    <button mat-stroked-button color="accent" [mat-dialog-close]="{ confirmed: false, success: false }">Cancel</button>
  </mat-dialog-actions>
